export const environment = {
  production: false,
  api: '',
  code: "",
  baseAuth:""
};